import has from '@dojo/framework/core/has';

import { Question, SvcArgs, singleSvc, svc } from './conversation-svc';

export const asyncLoad = async (args: SvcArgs): Promise<Question[]> => {
	const { method, sessionid, site, product, data, author_id, select } = args;
	let response: Question[];
	if (has('ati-use-single-rpc')) {
		response = await singleSvc.reportsrpc({
			method,
			sessionid,
			site,
			product,
			author_id,
			data,
			select
		});
	} else {
		switch (method) {
			case 'conversations':
				response = await svc.conversations({
					session_id: sessionid as number,
					author_id: author_id!,
					select
				});
				break;
			case 'update_conversations':
				response = await svc.update_conversations({
					session_id: sessionid as number,
					data: data!,
					select
				});
				break;
			default:
				response = {} as Question[];
				break;
		}
	}
	return response || [];
};

export default asyncLoad;
